export const language: any = {
  add_by_image: "ပုံမှတဆင့် ထည့်ပါ",
  add_image_by_camera: "ကင်မရာဖြင့် ရိုက်ပါ",
  add_image_by_gallery: "ဂါလာရီမှ ရွေးပါ",
  loading: "အရသာရှိသော အစားအစာ သုတေသနပြုနေပါသည်။\nကျေးဇူးပြု၍ ခဏစောင့်ပါ။",
  retry: "ထပ်မံကြိုးစားမည်",
  cancel: "ဖျက်သိမ်းမည်",
  yes: "ဟုတ်ကဲ့",
  no: "မဟုတ်ပါ",
  goToIngredient: "ပါဝင်ပစ္စည်းများ စိစစ်ရန်",
  goToRecipe: "ချက်ပြုတ် နည်းလမ်း စိစစ်ရန်",
  recipe: {
    title: "AI အသုတ်ချက်ပြုတ်နည်း",
    analysis_results: "ဖြေရှင်းမှုရလဒ်များ",
    ingredients: {
      title: "ပါဝင်ပစ္စည်းများ (၁ ဆန့်တန်)",
      view_more: "{number} ခုအထိ ပိုမိုကြည့်ရန်",
      view_less: "ပိတ်ရန်",
    },
    how_to_cook: "ချက်ပြုတ်နည်း",
    go_to_detail: "AI အသုတ်ချက်ပြုတ်နည်းကြည့်ရန်",
    description: "ဟင်းချက်နည်းအကြောင်းအရာ",
    calories: "ကယ်လိုရီ",
    time: "ချက်ပြုတ်ချိန်",
    ingredient: "အဓိကပါဝင်ပစ္စည်း",
    spice: "အခါးအငွေ့ပစ္စည်းများ",
    tip: "TIP",
  },
  ingredient: {
    title: "ပုံစံခွဲခြမ်းစိတ်ဖြာမှု",
    analysis_results: "ပုံစံခွဲခြမ်းစိတ်ဖြာမှုရလဒ်အရ ပါဝင်ပစ္စည်းများမှာ အောက်ပါအတိုင်းဖြစ်သည်။",
    add_to_cart: "စျေးဝယ်လှည်းသို့ ထည့်ရန်",
    add_to_my_ingredients: "ပါဝင်ပစ္စည်းများထည့်ရန်",
  },
  msg: {
    not_ingredients: `ဓာတ်ပုံက အလွန်ချိုသာတယ်၊\nဒါပေမယ့် ဒီနေရာက ဘာသာရပ်ပစ္စည်းအတွက်သာပါ။\nနောက်တစ်ကြိမ်မှာ အစားအသောက်ပစ္စည်းများကို\nဓာတ်ပုံရိုက်တင်ပေးပါ။\nချက်ပြုတ်နည်းရဲ့ လျှို့ဝှက်ချက်တွေက စောင့်နေပါတယ်!\nAI Chef ဆီသို့ ရောက်လိုက်ကြမလား?`,
    // AC-01-MSG-01
    not_recipes: `ဟုမ်း၊ ဒါကချက်ပြုတ်ထားတဲ့ဟင်းမဟုတ်ပါဘူး!\nကျွန်ုပ်တို့အနေနဲ့ ချက်ပြုတ်ထားတဲ့ဟင်းပုံတွေပဲခွဲခြမ်းစိတ်ဖြာနိုင်ပါတယ်။\nပြီးပြည့်စုံထားတဲ့ဟင်းပုံတစ်ပုံတင်ပါ။\nပါဝင်ပစ္စည်းခွဲခြမ်းစိတ်ဖြာမှုသို့ ရောက်မလား?`,
    not_found: "မတွေ့ပါ",
    unknow: `ဒီဓာတ်ပုံမှာ ဟင်းလျာများ သို့မဟုတ် ကုန်ကြမ်းများမဟုတ်တဲ့အရာကို ပုံရသလို ရှိပါတယ်။\nခန့်မှန်းရန်အတွက် ဟင်းလျာ သို့မဟုတ် ကုန်ကြမ်းများအကြောင်းဓာတ်ပုံ တင်ပေးပါက\nပိုမိုကောင်းမွန်စွာ ကူညီပေးနိုင်ပါမည်။`,
    upload_fail: `ယာယီအမှားကြောင့် တင်သွင်းမှု မအောင်မြင်ပါ။\nခဏနားပြီး ထပ်ကြိုးစားပါ။`,
    error: `ဝမ်းနည်းပါတယ်! ပုံစစ်ဆေးမှု မအောင်မြင်ပါ။\nပုံအသစ်တစ်ပုံ ရွေးပါ သို့မဟုတ်\nပိုမှန်ကန်သောပုံဖြင့် ထပ်ကြိုးစားပါ။`,
    bothType: `ဓာတ်ပုံတွင် ပါဝင်ပစ္စည်းများနှင့် ချက်ပြုတ်ပစ္စည်းများ နှစ်ခုလုံးပါရှိနေပါသည်!\nဓာတ်ပုံမှ ဘာကို စိစစ်မလဲ ရွေးပါ။`,
  },
}
